import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import { FormProvider } from 'react-hook-form';
import Button from '@/components/Button';
import useSKClubAuth from '@/hooks/useSKClubAuth';

export default function SKClubAuth() {
  const { login, logout, loading, isAuthenticated, firebaseUser } = useSKClubAuth();
  const form = useForm();

  const handleSubmit = async ({ email, password }) => {
    await login(email, password);
  };

  if (isAuthenticated) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className='relative group'
      >
        <div className='absolute -inset-[1px] bg-gradient-to-r from-primary-500/40 via-primary-500/20 to-primary-500/40 rounded-xl blur-[1px]' />
        <div className='relative flex items-center justify-between bg-gray-800 rounded-xl p-5 border border-gray-700/50'>
          <div className='flex items-center gap-4'>
            <div className='w-10 h-10 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center text-white font-bold text-sm'>
              {firebaseUser.email?.charAt(0).toUpperCase()}
            </div>
            <div>
              <p className='text-xs text-gray-500 uppercase tracking-wider font-medium'>Logged in as</p>
              <p className='text-white font-medium'>{firebaseUser.email}</p>
            </div>
          </div>
          <Button onClick={logout} theme='outline-gray'>
            Sign Out
          </Button>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className='relative max-w-sm mx-auto'
    >
      <div className='absolute -inset-[1px] bg-gradient-to-r from-primary-500/30 via-transparent to-primary-500/30 rounded-xl blur-[1px]' />
      <div className='relative bg-gray-800 rounded-xl p-6 border border-gray-700/50'>
        <p className='text-gray-400 text-sm mb-6'>
          Sign in with the email and password you linked in the Frik'd Up Fishies app.
        </p>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(handleSubmit)}>
            <div className='space-y-4'>
              <div>
                <label className='block text-sm font-medium text-gray-300 mb-2'>Email address</label>
                <input
                  type='email'
                  className='w-full bg-gray-700/80 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-colors'
                  placeholder='you@example.com'
                  {...form.register('email', { required: 'This field is required' })}
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-300 mb-2'>Password</label>
                <input
                  type='password'
                  className='w-full bg-gray-700/80 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-colors'
                  placeholder='Enter your password'
                  {...form.register('password', { required: 'This field is required' })}
                />
              </div>
            </div>

            <div className='mt-6'>
              <Button loading={loading} type='submit' className='w-full'>
                Sign In
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </motion.div>
  );
}
